import { Button } from '@/components/shadcn/button'
import { IconOpenInNewOutline } from '@icons/IconOpenInNewOutline'
import clsx from 'clsx'
import { useRef } from 'react'
import { PADDING_GAP } from '../../config'
import { ComponentActionsContainer } from '../shared/ComponentActionsContainer'
import { ComponentHeader } from '../shared/ComponentHeader'
import { ComponentTitle } from '../shared/ComponentTitle'
import { getComponentHeights } from '../utils'
import { ChartDialog } from './ChartDialog'
import { RenderChart } from './RenderChart'
import { ChartResponse } from './types-v2'
import { IconV2ExportOutline } from '@icons/IconV2ExportOutline'

export const ChartContentV2 = ({
  data,
  tileFilters,
  tileContainerRef,
}: {
  data: ChartResponse
  tileFilters?: React.ReactNode
  tileContainerRef: React.RefObject<HTMLDivElement>
}) => {
  const {
    uiSchema: { title, description, spec, emphasizeHeader },
  } = data
  const { config, ...specWithoutConfig } = spec
  const { headerHeight, contentHeight } = getComponentHeights(emphasizeHeader)
  const hasHeader = !!title && !!tileFilters
  const modalContentRef = useRef<HTMLDivElement>(null)

  return (
    <div className="flex h-full flex-col">
      {hasHeader && (
        <ComponentHeader emphasize={emphasizeHeader}>
          <div className="flex items-start gap-2">
            <ComponentTitle title={title} description={description} />
            <ChartDialog
              trigger={
                <Button size="icon" variant="ghost" className="size-7 shrink-0 px-0 py-0">
                  <IconV2ExportOutline size={20} />
                </Button>
              }
              title={title}
              description={description}
              tilefilters={tileFilters}
            >
              <div className="h-[calc(100vh-80px)] w-[calc(100vw-80px)]" ref={modalContentRef}>
                <div
                  style={{
                    marginTop: PADDING_GAP,
                    height: `calc(100% - 44px - ${headerHeight}px)`,
                  }}
                >
                  <RenderChart
                    hasHeader={hasHeader}
                    specWithoutConfig={specWithoutConfig}
                    config={config}
                    tileContainerRef={modalContentRef}
                  />
                </div>
              </div>
            </ChartDialog>
          </div>
          <ComponentActionsContainer>{tileFilters}</ComponentActionsContainer>
        </ComponentHeader>
      )}
      <div className={clsx({ 'pt-5': hasHeader })} style={{ height: contentHeight }}>
        <RenderChart
          hasHeader={hasHeader}
          specWithoutConfig={specWithoutConfig}
          config={config}
          tileContainerRef={tileContainerRef}
        />
      </div>
    </div>
  )
}
